import React, { type PropsWithChildren } from 'react';

import { Navigate } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { isAccommodationViewsImpressionsSalesEnabled } from './featureFlag';

type Props = PropsWithChildren<{
  user: Parameters<typeof isAccommodationViewsImpressionsSalesEnabled>[0];
  isLoading: boolean;
}>;

export default function AccommodationViewsImpressionsSalesRouteGate({ user, isLoading, children }: Props) {
  if (isLoading || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return isAccommodationViewsImpressionsSalesEnabled(user) ? <>{children}</> : <Navigate to="/commercial-ops" replace />;
}
